import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BA_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 34,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h34v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#BA_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v24H0V0z", fill: "#2E42A5" }), /* @__PURE__ */ e.createElement("path", { d: "M9 0h20v24L9 0z", fill: "#FECA00" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.107 2.794l-1.175.618.224-1.309-.95-.927L5.518.985l.588-1.191.588 1.19 1.314.192-.95.927.224 1.309-1.176-.618zM9.594 7.074l-1.176.618.224-1.309-.95-.927 1.314-.19.588-1.192.587 1.191 1.315.191-.951.927.224 1.31-1.175-.619zM12.863 11.238l-1.175.618.224-1.309-.951-.927 1.314-.19.588-1.192.588 1.191 1.314.191-.95.927.224 1.31-1.176-.619zM16.064 15.23l-1.175.617.224-1.308-.95-.928 1.313-.19.588-1.191.588 1.19 1.314.191-.95.928.224 1.309-1.176-.619zM19.513 19.337l-1.175.618.224-1.31-.95-.926 1.314-.191.587-1.191.588 1.19 1.315.192-.951.927.224 1.309-1.176-.618zM23.326 23.311l-1.176.619.225-1.31-.951-.927 1.314-.19.588-1.192.588 1.192 1.314.19-.951.927.224 1.31-1.175-.619z",
      fill: "#F7FCFF"
    }
  ))
);
export {
  t as default
};
